import loader from '../core/loader'
import { ajax } from '../core/ajax'
const _wxSDK = '//res.wx.qq.com/open/js/jweixin-1.3.2.js'

function initWexin (cb) {
  checkInited(cb)
  loader.sdkReady('wx', _wxSDK, sdk => {
    if (sdk.constructor === Error) {
      cb(sdk) // 异常也抛给前端
    } else {
      requestJSSDKAPI((status, res) => {
        if (status === 'success') {
          const wx = global.wx
          const selfApiList = ['login', 'getLocation', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'hideOptionMenu', 'showMenuItems', 'hideMenuItems', 'onMenuShareQQ', 'onMenuShareQZone', 'openLocation']
          const userApiList = global._SDK_API_LIST_ || []
          wx.config({
            beta: true,
            debug: false,
            ...res.data,
            jsApiList: selfApiList.concat(userApiList)
          })

          wx.ready(() => {
            cb(global.wx)
            global.__wechatReady__ = true
          })

          wx.error((res) => {
            cb(res)
            global.__wechatReady__ = false
          })
        } else {
          cb(res) // 失败回调给前端
        }
      })
    }
  })
}

function checkInited (cb) {
  if (global.__initWechat__) {
    // 进入这个逻辑说明其它的sdk正在初始化微信,那么需要等待初始化完毕
    waitForWechatReady(cb)
    return
  }
  global.__initWechat__ = true
}

function waitForWechatReady (cb) {
  function check () {
    if (global.__wechatReady__) {
      cb(global.wx)
      return
    }
    setTimeout(check, 100)
  }

  check()
}

function requestJSSDKAPI (callback) {
  const { url, method } = getSignApi()
  ajax({
    url,
    method,
    dataType: 'json',
    needEncrypt: true,
    data: {
      url: global.location.href.replace(/#.*/, '')
    },
    success (res) {
      callback('success', res)
    },
    error (status, statusText) {
      callback('failed', statusText)
    }
  })
}

function getSignApi () {
  // 宇宙大号
  return {
    url: '//common.diditaxi.com.cn/general/webEntry/jsapiticket',
    method: 'post'
  }
}

export function weixinReady (cb) {
  initWexin(cb)
}
